import Home from './pages/Home/Home';
import './App.css';

function App() {
  return <Home />;
}

export default App;
